import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { library_id: string };

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useDeleteMediaLibraryMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while deleting the media item',
    endpoint: ({ library_id }) => `/api/admin/whatsapp/media-library/${library_id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
